import React, {useCallback, useEffect, useState} from "react";
import {IFacility} from "../../../FactoryGame/types";
import {FacilityDetailView} from "../../../FactoryGame/Components/FacilityDetailView";
import {SatisfactoryAPI} from "../../../api/FactoryGame/index";
import {getRecipe} from "../../../FactoryGame/Helper/Recipes";

function decorate(facility: IFacility): IFacility {
    if (facility.type === 'Factory') {
        facility.recipe = getRecipe(facility.game, facility.recipeType);
    } else {
        facility.facilities = facility.facilities.map(subFacility => {
            subFacility.parentFacility = facility;
            return decorate(subFacility);
        });
    }
    facility.parentFacility = facility.parentFacility ?? null;
    return facility;
}

function findFacility(list: IFacility[], id: number): IFacility|null {
    return list.map(facility => (facility.id === id ? facility : findFacility(facility.facilities, id)))
        .reduce((a, b) => b ?? a, null);
}

type Props = {
    facilityId?: number
}

export function ToolSatis1({ facilityId }: Props) {
    const [ facilities, setFacilities ] = useState<IFacility[]|null>(null);

    const reload = useCallback(async (): Promise<void> => {
            const facilities = await SatisfactoryAPI.Facility.fetch();
            setFacilities(Object.values(facilities).map(decorate));
        },
        [setFacilities]
    )

    useEffect(() => {
        reload().then();
    }, []);

    if (facilities === null) {
        return <>Loading</>;
    }

    const requestedFacility = facilityId === undefined ? null : findFacility(facilities, facilityId);

    if (requestedFacility === null) {
        return <>
            {facilities.map(facility => <FacilityDetailView reload={reload} key={facility.id} facility={facility}/>)}
        </>;
    } else {
        return <>
            <FacilityDetailView reload={reload} facility={requestedFacility}/>
        </>
    }
}
